import { render, staticRenderFns } from "./micoapp_home.vue?vue&type=template&id=37022c5e&scoped=true"
import script from "./micoapp_home.vue?vue&type=script&lang=js"
export * from "./micoapp_home.vue?vue&type=script&lang=js"
import style0 from "./micoapp_home.vue?vue&type=style&index=0&id=37022c5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37022c5e",
  null
  
)

export default component.exports